<template>
    <div>
        <!-- <app-header></app-header> -->
        <div id="content" class="primary">
            <Row type="flex" justify="center" align="middle" class="code-row-bg" style="height: 100%;">
                <Col :xs="4" :lg="4">
                </Col>
                <Col :xs="6" :lg="8">
                    <img src="" style="margin: auto;">
                </Col>
                <Col :xs="6" :lg="3">
                </Col>
                <Col :xs="6" :lg="6">
                    <div>
                        <div style="margin:auto;background-color: #FFFFFF;text-align:center;border-radius: 6px;box-shadow: 0 3px 4px 0 rgba(0,0,0,0.15);">
                            <div style="width: 100%;height: 45%; padding: 30px;">
                                <p style="font-family: Helvetica-Bold; color:#333333;font-size:24px;letter-spacing: 0;line-height: 30px;margin-bottom: 20px;">Log in.</p>
                                <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
                                    <FormItem prop="userName" style="margin-top:6px">
                                        <Input type="text" size="large" v-model="formInline.userName" placeholder="Username/E-mail" style="width: 200px" @on-enter="handleSubmit('formInline')">
                                            <Icon type="ios-person-outline" slot="prepend"></Icon>
                                        </Input>
                                    </FormItem>
                                    <br>
                                    <FormItem prop="passWord" style="margin-top:6px">
                                        <Input type="password" size="large" v-model="formInline.passWord" placeholder="Password" style="width: 200px" @on-enter="handleSubmit('formInline')">
                                            <Icon type="ios-locked-outline" slot="prepend"></Icon>
                                        </Input>
                                    </FormItem>
                                    <br>
                                    <Checkbox style="font-family: Helvetica;font-size: 12px;color: #747D82;letter-spacing: 0;line-height: 18px;" v-model="isSaveUser">Remember me</Checkbox>
                                    <span style="font-family: Helvetica;font-size: 12px;color: #41B8BC;letter-spacing: 0;line-height: 18px;cursor:pointer;" @click="findPassword">Forgot password?</span>
                                    <br>
                                    <FormItem>
                                        <Button style="width: 200px;background: #41B8BC;margin-top:6px" :loading="loading" @click="handleSubmit('formInline')">
                                            <span v-if="!loading" style="font-family: Helvetica;font-size: 12px;color: #FFFFFF;line-height: 12px;">LOGIN</span>
                                            <span v-else style="font-family: Helvetica;font-size: 12px;color: #FFFFFF;line-height: 12px;">LOGIN...</span>
                                        </Button>
                                    </FormItem>
                                </Form>
                                <span style="font-family: Helvetica;font-size: 12px;color: #747D82;letter-spacing: 0;line-height: 18px;">Don’t have an account?</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <!-- <label>&nbsp;|&nbsp;</label> -->
                                <span style="font-family: Helvetica;font-size: 12px;color: #41B8BC;letter-spacing: 0;line-height: 18px;cursor:pointer;" @click="gotoRegister">Sign up</span>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col :xs="2" :lg="3">
                </Col>
            </Row>
            <div align="center">
                <!-- 验证google随机码的modal弹出框 -->
                <Modal
                    v-model="loginAuthenticationModal"
                    title="Enter Two-factor Authentication Code"
                    align="center"
                    :loading="authLoading">
                    <label style="font-size: 14px;">Enter the code generated by your Google Authenticator app.</label>
                    <Form ref="formAuthentication" :model="formAuthentication" :rules="ruleAuthentication" inline>
                        <FormItem prop="randomCode" style="margin-top:6px;width: 200px;">
                            <Input class="juzhong" type="text" v-model="formAuthentication.randomCode" style="width: 100px; height:30px;text-align: center;margin-top: 20PX;" placeholder="000000" size="large" :maxlength="6"></Input>
                        </FormItem>
                        <br>
                        <FormItem prop="authenticationSecret">
                            <input type="hidden" disabled v-model="formAuthentication.authenticationSecret" />
                        </FormItem>
                    </Form>
                    <label style="font-size: 14px;">Please contact our <a href="####">customer service</a> if you've lost access to your Google Authenticator app.</label>
                    <div slot="footer">
                         <Button type="primary" size="large" @click="modalCancel">Cancel</Button>
                         <Button type="primary" size="large" @click="submitRandomCode('formAuthentication')">Submit</Button>
                    </div>
                </Modal>
            </div>
        </div>
    </div>    
</template>
<style>
	.juzhong input::-ms-input-placeholder{text-align: center;}
    .juzhong input::-webkit-input-placeholder{text-align: center;}
    input{margin-left:-40px;/*这里的值可以改变光标的位置*/}
</style>
<script>
    import Vue from 'vue'
    import config from '../../config.js'
	export default{
		data(){
            const validateAuthenticationSecret = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('The authenticationSecret cannot be empty'));
                } else {
                    callback();
                }
            };
            const validateRandomCode = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('The randomCode cannot be empty'));
                } else if (!Number.isInteger(+value)) {
                    callback(new Error('Please enter a numeric value'));
                } else if((value+'').length !== 6) {
                    callback(new Error('Must be 6 digits'));
                } else {
                    callback();
                }
            };
			return {
                loading: false,
                authLoading: true,
                loginAuthenticationModal: false,
                isSaveUser: false,
                formInline: {
                    userName: '',
                    passWord: ''
                },
                formAuthentication: {
                    authenticationSecret: '',
                    randomCode: '',
                },
                userId: {
                    id: '',
                },
                ruleAuthentication: {
                    authenticationSecret: [
                        { validator: validateAuthenticationSecret, trigger: 'blur' }
                    ],
                    randomCode: [
                        { validator: validateRandomCode, trigger: 'blur' }
                    ]
                },
                ruleInline: {
                    userName: [
                        { required: true, message: 'Please enter your username or email', trigger: 'blur' }
                    ],
                    passWord: [
                        { required: true, message: 'Please enter the password', trigger: 'blur' },
                        { type: 'string', min: 8, message: 'The password length cannot be less than 8 bits', trigger: 'blur' }
                    ]
                }
            }
		},
        //页面加载调用获取cookie值
        mounted(){
            //浏览器窗口发生变化时同时变化DIV高度
            window.onresize=this.autodivheight();
            //读取cookie信息
            this.getCookie();
        },
		methods: {
            //自动获得div高度
            autodivheight(){
                //函数：获取尺寸
                //获取浏览器窗口高度
                var winHeight=0;
                if (window.innerHeight){
                    winHeight = window.innerHeight;
                }else if ((document.body) && (document.body.clientHeight)){
                    winHeight = document.body.clientHeight;
                }//通过深入Document内部对body进行检测，获取浏览器窗口高度
                if (document.documentElement && document.documentElement.clientHeight){
                    winHeight = document.documentElement.clientHeight;
                }
                //DIV高度为浏览器窗口的高度:winHeight - 66
                document.getElementById("content").style.height= winHeight +"px";
            },
            gotoRegister:function(){
                this.$router.push({name:'register'})
            },
            findPassword:function(){
                this.$router.push({name:'password'})
            },
            //登录请求
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        //校验成功后，发送登录请求
                        this.loading = true;
                        let url = config.baseUrl + "user/open/loginPost";
                        //判断复选框是否被勾选 勾选则调用配置cookie方法
                        if(this.isSaveUser){
                            //365天 * 10 = 3650天 = 10年
                            //保存十年,时间够久了，就算不清除数据，十年后电脑都成骨灰了
                            //传入账号名
                            this.setCookieUser(this.formInline.userName, 3650);
                            //传入密码
                            this.setCookiePassword(this.formInline.passWord, 3650);
                        }else{
                            //时间为-1天，就会自动失效
                            this.setCookieUser("", -1);
                            this.setCookiePassword("", -1);
                        }
                        let that =this;
                        this.$http.post(url,this.formInline).then(function(successData){
                            let data = successData.data;
                            if (data.resCode == 0) {
                                //登录成功
	                            // console.log(data.result.token);
                                that.$store.state.user.name = data.result.userName;
                                that.$store.state.user.token = data.result.token;
                                that.$store.state.user.id = data.result.id;
                                that.$Message.success('Login successful!');
                                localStorage.setItem("userName",data.result.userName);
                                localStorage.setItem("id",data.result.id);
								localStorage.setItem("token",data.result.token);
                                localStorage.setItem("image", data.result.image);
                                localStorage.setItem("invitationCode", data.result.invitationCode);
                                Vue.http.interceptors.push(function(request, next) {
                                    // 接口每次请求会跨域携带cookie
                                    request.credentials = true;
                                    // 请求headers携带参数
                                    request.headers.set('Authorization', 'Bearer '+ data.result.token);
                                    next();
                                });
                                that.formInline.userName = '';
                                that.formInline.passWord = '';
                                that.$router.push({name:'posting'});
                            } else if (data.resCode == -1000){
                                this.$Message.error('The user does not exist!');
                                this.loading = false;
                            } else if (data.resCode == -1001) {
                                this.$Message.error('Wrong password!');
                                this.loading = false;
                            } else if (data.resCode == -1004) {
                                this.$Message.error('Your account is not allowed to login,Please activate!');
                                this.loading = false;
                            } else if(data.resCode == -1005){
                                this.userId.id = data.result.id;
                                this.formAuthentication.authenticationSecret = data.result.authenticationSecret;
                                this.loading = false;
                                this.loginAuthenticationModal = true;
                            }
                        },function(errorData){
                            this.$Message.error('Fail!');
                            this.loading = false;
                        });
                    }else{
                        this.$Message.error('Fail!');
                        this.loading = false;
                    }

                })
            },
            //设置cookie
            setCookieUser(c_user, severalDays) {
                let currentDate = new Date();
                currentDate.setHours(currentDate.getHours() + (24 * severalDays));
                //字符串拼接cookie
                window.document.cookie="user"+ "=" +c_user+";path=/;expires=" + currentDate.toGMTString();
            },
            //设置cookie
            setCookiePassword(c_password, severalDays) {
                let currentDate = new Date();
                currentDate.setHours(currentDate.getHours() + (24 * severalDays));
                //字符串拼接cookie
               window.document.cookie="password"+"="+c_password+";path=/;expires=" + currentDate.toGMTString();
            },
            //读取cookie
            getCookie:function () {
                if (document.cookie.length>0) {
                    let arr=document.cookie.split('; ');
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判断查找相对应的值
                        if(arr2[0]=='user'){
                            //给输入框添值
                            this.formInline.userName=arr2[1];
                            if(arr2[1] !== null && '' !== arr2[1]){
                                this.isSaveUser = true;
                            }
                        }
                        if(arr2[0]=='password'){
                            //给输入框添值
                            this.formInline.passWord=arr2[1];
                            if(arr2[1] !== null && '' !== arr2[1]){
                                this.isSavePassword = true;
                            }
                        }
                    }
                }
            },
            //验证随机码是否正确
            submitRandomCode(name){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let url = config.baseUrl + "user/open/authenticationRandomCode";
                        this.$http.post(url, this.formAuthentication).then(function(successData){
                            let data = successData.data;
                            if (data.result) {
                                let userUrl = config.baseUrl + "user/open/userDto";
                                let that = this;
                                this.$http.post(userUrl, this.userId).then(function(successData){
                                    let data = successData.data;
                                    if (data.resCode == 0) {
                                        that.$store.state.user.name = data.result.userName;
                                        that.$store.state.user.token = data.result.token;
                                        that.$store.state.user.id = data.result.id;
                                        that.$Message.success('Login successful!');
                                        localStorage.setItem("userName",data.result.userName);
                                        localStorage.setItem("id",data.result.id);
                                        localStorage.setItem("token",data.result.token);
                                        localStorage.setItem("image", data.result.image);
                                        localStorage.setItem("invitationCode", data.result.invitationCode);
                                        Vue.http.interceptors.push(function(request, next) {
                                            // 接口每次请求会跨域携带cookie
                                            request.credentials = true;
                                            // 请求headers携带参数
                                            request.headers.set('Authorization', 'Bearer '+ data.result.token);
                                            next();
                                        });
                                        that.formInline.userName = '';
                                        that.formInline.passWord = '';
                                        that.formAuthentication.randomCode = '';
                                        that.authLoading = false;
                                        that.$nextTick(() => {
                                            that.authLoading = true;
                                        });
                                        that.loginAuthenticationModal = false;
                                        that.$router.push({name:'posting'});
                                    }else{
                                        this.$Message.error('Fail!');
                                    }
                                },function(errorData){
                                    this.$Message.error('Fail!');
                                    this.authLoading = false;
                                    this.$nextTick(() => {
                                        this.authLoading = true;
                                    });
                                });
                            }else{
                                this.$Message.error('Verification code error!');
                                this.formAuthentication.randomCode = '';
                                this.authLoading = false;
                                this.$nextTick(() => {
                                    this.authLoading = true;
                                });
                            }
                        },function(errorData){
                            this.$Message.error('Fail!');
                            this.authLoading = false;
                            this.$nextTick(() => {
                                this.authLoading = true;
                            });
                        });
                    }else{
                        this.formAuthentication.randomCode = '';
                        this.authLoading = false;
                        this.$nextTick(() => {
                            this.authLoading = true;
                        });
                    }
                })
            },
            //关闭模态框
            modalCancel:function(){
                this.loginAuthenticationModal = false;
            },
    	}
    } 
    // document.onkeydown = function (event) {
    //     var e = event || window.event || arguments.callee.caller.arguments[0];
    //     if (e && e.keyCode == 13) {
    //         alert(3);
    //     }
    // };
</script>



// WEBPACK FOOTER //
// Login.vue?50f045f6